










































































import {Component, Prop, Vue} from 'vue-property-decorator';
import {FormValidationService, MonitoringService, TValidationRule, WebService} from '../../services';
import {SessionStore} from '../../store';
import type {AxiosError} from 'axios';
import type {QInput} from 'quasar';
import type {TValidationResult} from '../../services';


export const DEFAULT_REQUEST_HEADER = 'Hi Friend! 👋';
export const DEFAULT_REQUEST_INSTRUCTIONS = 'For verification, please enter your mobile number and we will send you a PIN';
export const DEFAULT_VERIFY_HEADER = 'Welcome back! ✌️';

@Component
export default class EnterPhoneVerifyPin extends Vue {
	@Prop({default: DEFAULT_REQUEST_HEADER})
	requestHeader!: string;

	@Prop({default: DEFAULT_REQUEST_INSTRUCTIONS})
	requestInstructions!: string;

	@Prop({default: DEFAULT_VERIFY_HEADER})
	verifyHeader!: string;

	mode: 'request' | 'verify' = 'request';
	phoneNumberInput = '';
	pin = '';
	pinRequestLoading = false;
	pinVerifyLoading = false;
	verifyingPin = false;


	get phoneDigits() {
		return FormValidationService.digitsOnly(this.phoneNumberInput);
	}

	get phoneDigitsFull() {
		if(!this.phoneDigits.startsWith('1')) {
			return `1${this.phoneDigits}`;
		}

		return this.phoneDigits;
	}

	get phoneMask() {
		if(this.phoneDigits.startsWith('1')) {
			return '+D (DDD) DDD-DDDD';
		}
		return '(DDD) DDD-DDDD';
	}

	get phoneNumberRules(): Array<TValidationRule> {
		return [
			FormValidationService.rulePhoneNumberLength as TValidationRule,
		];
	}

	get pinMask() {
		return 'DDDDD';
	}

	get pinRules(): Array<TValidationRule> {
		return [
			(value: string): TValidationResult => {
				return (value.length === 5) || 'Please enter a valid PIN';
			}
		];
	}


	inputPin() {
		if(this.pin.length === 5) {
			this.pinVerify();
		}
	}

	async pinRequest(voice = false) {
		this.pinRequestLoading = true;
		try {
			await WebService.pinRequest(this.phoneDigitsFull, voice);
			this.mode = 'verify';
			this.$nextTick(() => {
				(this.$refs.pinInput as HTMLInputElement)?.focus();
			});
		} catch(error: unknown) {
			console.error(error);
			let errorMessage = 'Unknown';
			if((error as Record<string, unknown>)?.isAxiosError &&
				(error as AxiosError)?.response?.data?.errors?.length > 0
			) {
				// optional chaining here is just to appease TypeScript
				errorMessage = (error as AxiosError).response?.data?.errors[0];
			}
			this.$q.dialog({
				title: 'Error',
				message: `There was a problem sending your SMS PIN: ${errorMessage}`,
			});
			MonitoringService.captureException(error);
		} finally {
			this.pinRequestLoading = false;
		}
	}

	async pinVerify() {
		if(this.verifyingPin) {
			return;
		}

		this.$emit('before-pin-verify');

		this.verifyingPin = true;
		this.pinVerifyLoading = true;

		try {
			const response = await WebService.pinVerify(this.phoneDigitsFull, this.pin);
			SessionStore.setAuthConfig(response);

			/*
			 * You will probably want to watch SessionStore.authConfig and/or
			 * CustomerProfileStore.customerProfile for changes and then act.
			 * See App.vue or Landing.vue for examples.
			 */
			this.$emit('pin-verify');
		} catch(error) {
			// We only want to reset these to false if we fail.
			// If we are successful more things need to load and
			// we don't want the verify button to be clickable
			// until those things are done (and we navigate away)
			this.pinVerifyLoading = false;
			this.verifyingPin = false;

			console.error(error);
			this.$q.dialog({
				title: 'Error',
				message: 'There was a problem verifying your PIN.'
			});
			MonitoringService.captureException(error);
		} finally {
			this.$emit('after-pin-verify');
		}
	}

	async sendViaVoice() {
		this.mode = 'request';
		await this.pinRequest(true);
	}

	tryAgain() {
		this.pin = '';
		(this.$refs.pinInput as QInput).resetValidation();
		this.mode = 'request';
	}
}
